import { all, call, fork, put, select, takeEvery } from 'redux-saga/effects';
import { dialogueRequest } from '../../../services/product';
import { DialogueRegisterState } from 'core/slices/register';
import { selectToken } from 'core/selectors/product/token';
import { ISessionReducer, IToken, Mode } from 'core/slices/session';
import { authRequest } from 'core/services/authentication';
import { AnyAsyncThunk, FulfilledActionFromAsyncThunk } from '@reduxjs/toolkit/dist/matchers';
import { selectSession } from 'core/selectors/product/session';
import { CourseNodeStatus, ICourseNodeDAO } from 'types/domain/course';
import { selectCourseNode } from 'core/selectors/admin/courseNode';

function* authRequestSaga(action: FulfilledActionFromAsyncThunk<AnyAsyncThunk>) {
  const courseNodeDAO: ICourseNodeDAO = yield select(state => selectCourseNode(state, action.meta.arg.courseNodeId));
  const session: ISessionReducer = yield select(selectSession);
  const token: IToken = yield select(selectToken);
  if (session.mode === Mode.LEARNING && courseNodeDAO && courseNodeDAO.status === CourseNodeStatus.PRIVATE)
    yield put(
      yield call(dialogueRequest, {
        token: token.token,
        courseNodeId: courseNodeDAO.id,
        courseProgressId: token.courseProgressId,
        state: DialogueRegisterState.SUBMITTED,
      }),
    );
}

function* watchAuthRequest() {
  yield takeEvery(authRequest.fulfilled, authRequestSaga);
}

export function* verificationSaga() {
  yield all([fork(watchAuthRequest)]);
}
